import { gql } from 'graphql.macro';

export const getSupportScreenSharesTemplate = gql`
    query supportScreenShares {
        supportScreenShares {
            code
            userName
            userEmail
            organizationName
            organizationType
            startedAt
            isCustomerSharing
            viewers
        }
    }
`;
